import { cn } from "@/lib/utils";

const DIGITS = "0123456789".split("");

function Digit({ d }) {
  return (
    <span className="roll-digit" aria-hidden="true">
      <span className="roll-strip" style={{ transform: `translateY(-${d * 10}%)` }}>
        {DIGITS.map((n) => (
          <span key={n}>{n}</span>
        ))}
      </span>
    </span>
  );
}

// Odometer-style number; digits roll individually as the value changes.
export function RollingNumber({ value, format, className, ...rest }) {
  const str = format(value);
  const chars = str.split("");
  return (
    <span className={cn("roll", className)} aria-label={str} role="img" data-value={str} {...rest}>
      {chars.map((ch, i) => {
        const key = chars.length - i;
        return /\d/.test(ch) ? (
          <Digit key={`d${key}`} d={Number(ch)} />
        ) : (
          <span key={`s${key}`} aria-hidden="true">
            {ch}
          </span>
        );
      })}
    </span>
  );
}
